import React from "react";
import FAQSection from '../components/FAQSection';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const RoadAssitance = () => {
    return (
        <><Helmet>
            <title>24/7 Road Assistance | MM AutoTech UK</title>
            <meta
                name="description"
                content="Fast and reliable roadside assistance across the UK. MM AutoTech ensures your customers get back on the road quickly." />
            <link rel="canonical" href="https://mmautotech.com/services/road-assistance" />
        </Helmet><div className=" mx-auto">

                {/* Hero Section */}
                <section class="relative bg-cover bg-center bg-no-repeat h-[80vh]">
                    <img
                        src="/assets/road.png"
                        alt="Road Assistance"
                        class="absolute inset-0 w-full h-full object-cover z-0" />

                    <div class="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center px-4 text-center z-10">
                        <h1 className="text-white text-2xl sm:text-3xl md:text-4xl px-4 py-2 rounded">
                            If you require any road side assistance service,<br />
                            simply call us
                        </h1>
                        <a href="tel:+447747762059" className="block text-yellow-400 text-xl sm:text-2xl font-semibold mt-4 cursor-pointer hover:underline">
                            +44 7747 762059
                        </a>
                        <p class="text-gray-300 text-sm sm:text-base mt-2">
                            Less than 30 min arrival (the call is free)
                        </p>
                    </div>
                </section>


                <section className="py-16 px-6 md:px-16 bg-white text-gray-900 text-center">
                    <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
                        Providing you excellent service
                    </h2>

                    <p className="text-sm md:text-base text-gray-600 mb-12">
                        MMAutoTech is just a call away!
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
                        {[
                            {
                                title: 'TWO CRANE MANIPULATOR',
                                img: 'https://media.istockphoto.com/id/1324030624/photo/the-woman-calls-the-roadside-assistance-service.jpg?s=612x612&w=0&k=20&c=SF02lCQOtrHwmWbltboclaN4LrYAFfVaw-H0WS3kYNE=', // Replace with actual path
                                specs: [
                                    'Load capacity up to 5 tons',
                                    'Platform length 4.7 meters',
                                    'Width 2 meters',
                                    'Boom reach 10 meters',
                                ],
                            },
                            {
                                title: 'HYDRAULIC PLATFORM TOW TRUCK',
                                img: 'https://t3.ftcdn.net/jpg/04/56/42/22/360_F_456422241_mmqjKN1x7gySgbYg4f8uJNbto0zHSHYf.jpg',
                                specs: [
                                    'Load capacity up to 5 tons',
                                    'Platform length 4.5 meters',
                                    'Width 2 meters',
                                    'Load time 1 minute',
                                ],
                            },
                            {
                                title: 'CRANE MANIPULATOR',
                                img: 'https://images.ctfassets.net/f8ma74glmej5/675ZCrmc5qCAQsC3d3Fz7k/263fcd57f0e0c9ffa392a9de1ce72e55/emergency-roadside-assistance.jpg?w=1200&h=675&fl=progressive&q=95&fm=jpg',
                                specs: [
                                    'Load capacity up to 3.5 tons',
                                    'Platform length 3.1 meters',
                                    'Width 1.8 meters',
                                    'Boom reach 5 meters',
                                ],
                            },
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
                            >
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className="w-full h-48 object-cover" />
                                <div className="p-5 text-left">
                                    <h3 className="font-bold text-gray-900 text-lg mb-2">{item.title}</h3>
                                    <p className="text-sm text-gray-700 mb-3">
                                        Need help on the road? MMAutoTech is just a call away!
                                    </p>
                                    <ul className="list-disc list-inside text-sm text-gray-600 space-y-1">
                                        {item.specs.map((point, i) => (
                                            <li key={i}>{point}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/*our tow truck*/}

                <section className="py-16 px-6 md:px-16 bg-white border border-gray-300 text-center">
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-10">Our tow trucks</h2>

                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 max-w-6xl mx-auto">
                        {[
                            'https://gutenix.com/demo/brizy/towinghelp/wp-content/uploads/brizy/8/assets/images/iW=438&iH=328&oX=0&oY=0&cW=438&cH=328/img-4.jpg',
                            'https://gutenix.com/demo/brizy/towinghelp/wp-content/uploads/brizy/8/assets/images/iW=438&iH=328&oX=0&oY=0&cW=438&cH=328/img-5.jpg',
                            'https://gutenix.com/demo/brizy/towinghelp/wp-content/uploads/brizy/8/assets/images/iW=438&iH=328&oX=0&oY=0&cW=438&cH=328/img-6.jpg?s=612x612&w=0&k=20&c=OqEFByq1NYEDMybiFRTY8QExMMVhRXSBzmD61uHoOLg=',
                            'https://gutenix.com/demo/brizy/towinghelp/wp-content/uploads/brizy/8/assets/images/iW=438&iH=328&oX=0&oY=0&cW=438&cH=328/img-7.jpg',
                            'https://gutenix.com/demo/brizy/towinghelp/wp-content/uploads/brizy/8/assets/images/iW=438&iH=328&oX=0&oY=0&cW=438&cH=328/img-8.jpg',
                            'https://gutenix.com/demo/brizy/towinghelp/wp-content/uploads/brizy/8/assets/images/iW=438&iH=328&oX=0&oY=0&cW=438&cH=328/img-9.jpg',
                            'https://gutenix.com/demo/brizy/towinghelp/wp-content/uploads/brizy/8/assets/images/iW=438&iH=328&oX=0&oY=0&cW=438&cH=328/img-11.jpg',
                            'https://gutenix.com/demo/brizy/towinghelp/wp-content/uploads/brizy/8/assets/images/iW=438&iH=328&oX=0&oY=0&cW=438&cH=328/img-5.jpg',
                        ].map((url, index) => (
                            <div
                                key={index}
                                className="overflow-hidden rounded shadow hover:shadow-md transition-shadow duration-300"
                            >
                                <img
                                    src={url}
                                    alt={`Tow truck ${index + 1}`}
                                    className="w-full h-40 object-cover" />
                            </div>
                        ))}
                    </div>
                </section>



                {/*marketing anaylis*/}


                <section className="py-16 px-6 md:px-16 bg-blue-200">
                    <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-8">

                        {/* Image on the left */}
                        <div className="flex-shrink-0">
                            <img
                                src="/assets/img6.png"
                                alt="Yellow Tow Truck"
                                className="w-full max-w-sm rounded-md shadow-md object-cover" />
                        </div>

                        {/* Text on the right */}
                        <div className="w-full md:w-1/2 flex flex-col items-end text-right">
                            <p className="font-semibold text-lg md:text-xl text-gray-900 mb-2">
                                Simply call our 24 hour emergency number
                            </p>
                            <p className="font-extrabold text-3xl md:text-4xl text-black mb-4">
                                +44 7747 762059
                            </p>
                            <p className="text-xs md:text-sm text-gray-700">
                                Less than 30 min arrival (the call is free)
                            </p>
                        </div>
                    </div>
                </section>



                {/* Our Customer Say */}
                <section className="py-16 px-4 md:px-10 bg-white">
                    <div className="max-w-6xl mx-auto">
                        <h2 className="text-3xl font-bold text-blue-900 mb-2">Our Customer Say</h2>
                        <div className="w-24 border-b-4 border-yellow-400 mb-4"></div>
                        <p className="text-gray-600 mb-10">Here’s what our customers are saying about MM Auto Tech.</p>

                        <div className="grid md:grid-cols-2 gap-6">
                            {/* Testimonial 1 */}
                            <div className="bg-blue-50 p-6 rounded-lg shadow-sm border-b-4 border-yellow-400">
                                <p className="text-blue-700 mb-4">
                                    <span className="text-2xl font-serif text-gray-400">“</span>
                                    We are so pleased with the expert service and attention to detail from MMAutoTech. They made sure our car was running smoothly again in no time!
                                </p>
                                <div className="flex items-center mt-4">
                                    <img
                                        src="https://randomuser.me/api/portraits/men/32.jpg"
                                        alt="Howard Chavez"
                                        className="w-10 h-10 rounded-full mr-3" />
                                    <span className="text-sm font-medium text-gray-800">Howard Chavez</span>
                                </div>
                            </div>

                            {/* Testimonial 2 */}
                            <div className="bg-blue-50 p-6 rounded-lg shadow-sm border-b-4 border-yellow-400">
                                <p className="text-blue-700 mb-4">
                                    <span className="text-2xl font-serif text-gray-400">“</span>
                                    The team at MMAutoTech provided excellent customer service and helped me find the perfect used car for my needs. Highly recommended!
                                </p>
                                <div className="flex items-center mt-4">
                                    <img
                                        src="https://randomuser.me/api/portraits/women/45.jpg"
                                        alt="Lucas Elliot"
                                        className="w-10 h-10 rounded-full mr-3" />
                                    <span className="text-sm font-medium text-gray-800">Lucas Elliot</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>




                {/* Call to Action Section */}
                <section className="py-16 bg-[#f4f6fc] text-black px-4 sm:px-6 lg:px-8">
                    <div className="max-w-xl mx-auto text-center">
                        <p className="uppercase tracking-wider text-sm mb-2 font-semibold text-gray-700">
                            Emergency Call 24/7
                        </p>
                        <p className="text-3xl sm:text-4xl font-bold text-[#111827] mb-2">
                            +44 7747 762059
                        </p>
                        <div className="w-12 h-1 bg-yellow-400 mx-auto mb-6"></div>
                        <p className="uppercase text-sm font-medium text-gray-700 mb-6 tracking-widest">
                            Book an appointment today
                        </p>
                        <Link to="/contact">
                            <button className="inline-flex items-center gap-2 bg-[#1f2e9f] text-white px-6 py-3 rounded-md font-bold shadow-md relative">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M8 7V3M16 7V3M3 11h18M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                                Book Now
                                <span className="absolute right-0 top-1/2 transform -translate-y-1/2 h-full w-1 bg-yellow-400 rounded-r-md"></span>
                            </button>
                        </Link>
                    </div>
                </section>

                <FAQSection />

            </div></>
    );
};

export default RoadAssitance;
